// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'youtube';

export const Component = () => (
  <path
    fill='currentColor'
    d='M12.31 9.708a.535.535 0 0 0 .311-.518.535.535 0 0 0-.31-.517L7.277 5.5c-.207-.138-.414-.138-.656 0-.207.104-.31.31-.31.552v6.276c0 .241.103.448.31.552a.557.557 0 0 0 .31.103.663.663 0 0 0 .346-.103l5.034-3.173zm5.346-2v2.965c0 .345-.035.794-.104 1.345a8.1 8.1 0 0 1-.207 1.449 2.24 2.24 0 0 1-.69 1.207c-.31.31-.723.517-1.207.586-1.724.172-3.93.241-6.62.241s-4.897-.069-6.62-.24A2.107 2.107 0 0 1 1 14.673a2.237 2.237 0 0 1-.69-1.207 8.144 8.144 0 0 1-.206-1.449c-.07-.551-.104-1-.104-1.345V7.708c0-.345.034-.793.104-1.345A8.093 8.093 0 0 1 .31 4.915 2.24 2.24 0 0 1 1 3.707c.31-.31.723-.517 1.206-.586 1.724-.172 3.932-.241 6.62-.241s4.897.07 6.622.241c.482.07.896.276 1.207.586.344.31.586.724.69 1.208a8.2 8.2 0 0 1 .206 1.448c.07.552.104 1 .104 1.345z'
  />
);

export const viewBox = '0 0 18 18';
